import { BaseModifier } from "./base-modifier";
export class SelectMultipleModifier extends BaseModifier {
    constructor() {
        super("select[multiple]");
    }
    initialize() {
        this.input.jQueryObject.select2();
    }
    prepareValue(formData, name) {
        return new Promise((resolve) => {
            formData.delete(name);
            const first = undefined;
            this.input.jQueryObject
                .find("option:selected")
                .each((i, selectedElement) => {
                formData.append(name, $(selectedElement).val());
            });
            resolve();
        });
    }
}
